export default {
  // Base palette (from default template)
  green: '#389d34',
  red: '#e15c55',
  yellow: '#EDCB38',
  orange: '#e97c16',
  transparent: 'rgba(0, 0, 0, 0)',
  black: 'black',
  gray: '#4e4e50',
  white: '#ffffff',

  // Semantic text colors [@dark, @light]
  title: [
    '--gray 1 -168',
    '--gray 1 +168',
  ],
  caption: [
    '--gray 1 -68',
    '--gray 1 +68',
  ],
  paragraph: [
    '--gray 1 -42',
    '--gray 1 +42',
  ],
  disabled: [
    '--gray 1 -26',
    '--gray 1 +26',
  ],
  line: [
    '--gray 1 -16',
    '--gray 1 +16',
  ],

  // Base named colors
  codGray: '#171717',
  blue: '#0474f2',

  // Portfolio "Cyber-Gloss" tokens
  cyber: '#00f0ff',
  neon: '#8b5cf6',
  surface: '#09090b',
  glass: '#18181b',
  glow: '#06b6d4',
}
